var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,10c-12.15,0 -22,9.85 -22,22c0,12.15 9.85,22 22,22c12.15,0 22,-9.85 22,-22c0,-12.15 -9.85,-22 -22,-22zM32,14c9.941,0 18,8.059 18,18c0,9.941 -8.059,18 -18,18c-9.941,0 -18,-8.059 -18,-18c0,-9.941 8.059,-18 18,-18zM41.04102,23.33789c-0.50794,-0.05859 -1.14612,0.08064 -1.85937,0.33789c-1.303,0.47 -17.95792,7.54217 -18.91992,7.95117c-0.911,0.388 -1.77439,0.81088 -1.77539,1.42188c0,0.43 0.25498,0.67283 0.95898,0.92383c0.732,0.262 2.57797,0.82009 3.66797,1.12109c1.05,0.289 2.24406,0.03709 2.91406,-0.37891c0.709,-0.441 8.90128,-5.92234 9.48828,-6.40234c0.587,-0.48 1.05617,0.13619 0.57617,0.61719c-0.48,0.481 -6.1037,5.93541 -6.8457,6.69141c-0.9,0.918 -0.26025,1.869 0.34375,2.25c0.689,0.435 5.64948,3.76092 6.39648,4.29492c0.747,0.534 1.50327,0.77539 2.19727,0.77539c0.694,0 1.0593,-0.91461 1.4043,-1.97461c0.405,-1.241 2.30216,-13.61473 2.53516,-16.05273c0.071,-0.739 -0.16214,-1.23022 -0.61914,-1.44922c-0.13825,-0.06625 -0.29358,-0.10742 -0.46289,-0.12695z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegramIcon.691908dc2a5bb74d688061dddd3017a0.svg";
export { ForwardRef as ReactComponent };